// 服务前缀 admin or tenantadmin
export const API_CONTEXT = 'admin';
// 保税业务
export const API_CONTEXT_BD = 'bonded';
// 主数据
export const API_CONTEXT_MD = 'master-data';
// 轨迹、日志
export const API_CONTEXT_LOGS = 'logs';
